module.exports = "/images/story_profile.png?db5fbffaf45ad50aff8f904faaf4f8bd";